import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  providerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  providerColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    minWidth: 0,
  },
  providerSecondary: {
    color: theme.palette.text.secondary,
  },
  providerName: {
    fontWeight: 500,
  },
  formSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(2, 0),
    gap: theme.spacing(1),
  },
}));
